module.exports = __webpack_public_path__ + "img/หอยกาบ.c6847892.jpg";